import React, { useContext } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AuthContext } from "./context/AuthContext";
import EditorialNavbar from "./components/EditorialNavbar";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import NewsPage from "./pages/NewsPage";
import StorePage from "./pages/StorePage";
import ContactPage from "./pages/ContactPage";
import AccountPage from "./pages/AccountPage";
import ClipsPage from "./pages/ClipsPage";
import HighlightsPage from "./pages/HighlightsPage";
import PublicProfilePage from "./pages/PublicProfilePage";
import StreamersPage from "./pages/StreamersPage";
import SearchPage from "./pages/SearchPage";
import TwitchCallback from "./pages/TwitchCallback";
import NotFoundPage from "./pages/NotFoundPage";
import WaitlistPage from "./pages/WaitlistPage";
import FollowSuggestionsPage from "./pages/FollowSuggestionsPage";
import HighlightSharePage from "./pages/HighlightSharePage";
import { NotificationProvider } from "./context/NotificationContext";
import { Toaster } from "./components/ui/sonner";

// Shows WaitlistPage for anyone who isn't beta approved.
// Allows contact page through so registered users can reach out.
const BetaGate = ({ children }) => {
  const { isLoggedIn, isBeta } = useContext(AuthContext);
  // isBeta === null means still loading — don't flash the waitlist
  if (isBeta === null) return null;
  if (!isLoggedIn || isBeta === false) return <WaitlistPage />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Always accessible — auth flow + contact */}
              <Route path="/auth/twitch/callback" element={<TwitchCallback />} />
              <Route path="/contact"              element={<><EditorialNavbar /><ContactPage /></>} />

              {/* Public — no beta gate */}
              <Route path="/follow-suggestions" element={<FollowSuggestionsPage />} />
              <Route path="/highlights/:id"     element={<HighlightSharePage />} />

              {/* Everything else is beta gated */}
              <Route path="/"                  element={<BetaGate><EditorialNavbar /><HomePage /></BetaGate>} />
              <Route path="/about"             element={<BetaGate><EditorialNavbar /><AboutPage /></BetaGate>} />
              <Route path="/news"              element={<BetaGate><EditorialNavbar /><NewsPage /></BetaGate>} />
              <Route path="/store"             element={<BetaGate><EditorialNavbar /><StorePage /></BetaGate>} />
              <Route path="/account"           element={<BetaGate><EditorialNavbar /><AccountPage /></BetaGate>} />
              <Route path="/account/clips"     element={<BetaGate><EditorialNavbar /><ClipsPage /></BetaGate>} />
              <Route path="/highlights"        element={<BetaGate><EditorialNavbar /><HighlightsPage /></BetaGate>} />
              <Route path="/profile/:username" element={<BetaGate><EditorialNavbar /><PublicProfilePage /></BetaGate>} />
              <Route path="/streamers"         element={<BetaGate><EditorialNavbar /><StreamersPage /></BetaGate>} />
              <Route path="/search"            element={<BetaGate><EditorialNavbar /><SearchPage /></BetaGate>} />
              <Route path="*"                  element={<BetaGate><EditorialNavbar /><NotFoundPage /></BetaGate>} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </div>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
